import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

import { Search, UserProfileImage } from '@domain-group/suit-theme'

import searchFn from '@functions/search'

import type { UserModel } from '@models/types'

import type { EntityOptions } from '@redux/modules/types'

type MapUserResultsParams = {
  secondaryTextProperty?: string,
  selectedIds?: number[],
  users: UserModel[],
}

const mapUserResults = (params: MapUserResultsParams) => {
  const {
    secondaryTextProperty = '', selectedIds = [], users,
  } = params

  const filteredUsers = users.filter(user => !selectedIds.includes(user.id))

  const results = {
    groups: [
      {
        key: 'user',
        title: 'USERS',
        items: filteredUsers
          .map((user) => {
            // @ts-expect-error
            const imageUrl = user?.image?.thumb_url ?? ''
            // @ts-expect-error
            const secondaryText = user?.[secondaryTextProperty] ?? ''

            return {
              ...user,
              iconLeft: (
                <UserProfileImage imageUrl={imageUrl}>
                  <FontAwesomeIcon icon={faUser} />
                </UserProfileImage>
              ),
              key: `User-${user.id}`,
              secondaryText: secondaryTextProperty === 'id' ? `#${secondaryText}` : secondaryText,
              text: user.full_name,
            }
          }),
      },
    ],
  }

  return results
}

interface UserSearchProps {
  callbacks: {
    onChange?: (value: string) => void,
    selectItem: (item: UserModel) => void,
  },
  endpoint?: string,
  requestOptions?: EntityOptions,
  secondaryTextProperty?: string,
  selectedIds?: number[],
  value?: string,
}

const UserSearch = (props: UserSearchProps) => {
  const {
    callbacks: {
      onChange,
      selectItem,
    },
    endpoint = 'users.json',
    requestOptions,
    secondaryTextProperty,
    selectedIds,
    value,
  } = props

  return (
    <Search
      callbacks={{
        onChange,
        // @ts-expect-error TS2322
        search: searchFn,
        // @ts-expect-error TS2322
        selectItem,
        // @ts-expect-error TS2322
        mapResults: users => mapUserResults({
          // @ts-expect-error TS2322
          secondaryTextProperty, selectedIds, users,
        }),
      }}
      debounceInterval={300}
      endpoint={endpoint}
      forwardProps={{
        closeOnSelect: true,
        setStringOnSelect: false,
        showOnFocus: true,
      }}
      requestOptions={{
        ...requestOptions,
        // @ts-expect-error TS2322
        include_image_sizes: true,
        // @ts-expect-error TS2322
        include_user_image: true,
      }}
      value={value}
    />
  )
}

export default UserSearch
